module.exports = __webpack_public_path__ + "img/cq9_slot.e6cb3f5d.png";